<template>
    <b-container fluid>
        <v-select id="tagChooser" v-model="object" class="style-chooser" label="id" :options="objects"
            :filterable="false" @search="searchValueUpdated">
            <template slot="option" slot-scope="object">
                {{ optionLabel(object) }}
            </template>
            <template slot="selected-option" slot-scope="object">
                {{ optionLabel(object) }}
            </template>
        </v-select>
    </b-container>
</template>

<script lang="ts">
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { Tag, TagEntityType } from '../models/Tag';
import axios from 'axios';
import { debounce } from 'throttle-debounce';
import { NotificationOptions } from '@/util/NotificationOptionsPresets';

@Component({
    name: "TagPickerComponent",
    components: {},
})
export default class TagPickerComponent extends Vue {
    private object: any = null;
    private objects: any[] = [];
    @Prop() private value!: Tag;
    // Scope the search to a single entity type so a drug edit page only surfaces drug tags, etc.
    @Prop({ default: TagEntityType.Drug }) private entityType!: TagEntityType;

    optionLabel(option: Tag) {
        return `ID:${option.id} ${option.name}`;
    }

    @Watch('object') objectUpdated(value: Tag | null, oldValue: Tag | null) {
        if (!value) return;
        if (value.id && (!oldValue || oldValue.id != value.id)) {
            this.fetchTag(value);
        }
    }

    fetchTag(tag: Tag) {
        axios.get(`/Tag/${tag.id}`)
            .then(response => {
                this.$emit('input', response.data);
            })
            .catch(error => {
                console.warn(error);
                this.$notification(NotificationOptions.error(error));
            });
    }
    private throttledSearch: Function = debounce(500, (loading, searchValue) => { this.onSearch(loading, searchValue) });
    searchValueUpdated(value: string, loading: any) {
        if (!value) return;
        loading(true);
        this.throttledSearch(loading, value);
    }
    onSearch(loading: any, searchValue: string) {
        if (!searchValue.length) return;
        axios.get(`/Tag/`, { params: { searchTerm: searchValue, entityType: this.entityType } })
            .then(response => {
                this.objects = response.data;
            })
            .catch(error => {
                console.warn(error);
                this.$notification(NotificationOptions.error(error));
            })
            .finally(() => {
                loading(false);
            })
    }

}
</script>

<style scoped></style>
